import script from "./xianqing1.vue?vue&type=script&setup=true&lang=js"
export * from "./xianqing1.vue?vue&type=script&setup=true&lang=js"

import "./xianqing1.vue?vue&type=style&index=0&id=aa750338&lang=less&scoped=true"
script.__scopeId = "data-v-aa750338"

export default script